import BaseComponent from "@js/components/base_component.jsx";

import EuiUserSettingsForm from "@js/components/eui/user_settings/form.jsx";

class EuiUserSettingsShow extends BaseComponent {

  render() {
    return (
      <EuiUserSettingsForm { ...this.props } editing={ false } />
    );
  }

}

export default EuiUserSettingsShow;
